import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import relativeTime from "dayjs/plugin/relativeTime";
import { RecoilRoot } from "recoil";
import { ThemeProvider } from "styled-components";
import UserProvider from "./lib/providers/UserProvider";
import { theme } from "./styles/theme";
import ErrorBoundary from "./error/errorBoundary";
import { Routes } from "./core/Routes";
import NaverMapLoader from "./components/atoms/NaverMapLoader";

dayjs.extend(relativeTime);
dayjs.locale("ko");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const MyApp = () => (
  <ThemeProvider theme={theme}>
    <QueryClientProvider client={queryClient}>
      <NaverMapLoader />
      <RecoilRoot>
        {/* 상태 체크 */}
        <UserProvider>
          <ErrorBoundary>
            <Routes />
          </ErrorBoundary>
        </UserProvider>
      </RecoilRoot>
    </QueryClientProvider>
  </ThemeProvider>
);

export default MyApp;
